export default { 
  hd7b8e7e767a15268af363f05f2f10594: [[({}, []) => ["Biometric Consent Agreement"], {}]],
  hfd1e282390c3ae8bcbcddf1408bb1791: [[({}, []) => ["Please read and agree to the Biometric Consent Agreement."], {}]] 
}